export const jobInfo = {
  title: "Software Engineer",
  company: "Weill Cornell Medicine"
}

export const skillsList = [
  'TypeScript / JavaScript',
  'React / React Native',
  'Node.js / REST APIs',
  'Python',
  'Flutter / Dart',
  'Swift / Kotlin',
  'AWS / Azure / Terraform / Docker',
  'PostgreSQL / MongoDB / DynamoDB',
  'CI/CD (CircleCI, Fastlane, GitHub Actions)',
  'OAuth 2.0 / SAML / KYC',
  'Datadog / Mixpanel / Looker',
  'Claude AI / OpenAI / AI Tooling',
]

export const projects = [
  {
    title: 'Hire Signal',
    description: 'Automated job board monitor that polls Greenhouse career pages, scores listings with Claude AI, and sends Discord notifications for high-fit roles. Runs autonomously on GitHub Actions with Turso as the cloud database. Built with TypeScript, Node.js, and the Anthropic API.',
    image:
      'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExczZoYjJ0eGJwczl4c2V6OHM5ejV2M25wdjhhN28yZHRwajFsdTFxOCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/74Kw9Ao42YbiFIsxDD/giphy.gif',
    link: 'https://github.com/AndrewPalet/hire-signal',
  },
  {
    title: 'Vet Payment App',
    description: 'This is a Vet Payment Mobile App created in Flutter. The project includes a backend API created in NodeJS which hosts a static JSON database which the mobile app calls to get and update user information for the app',
    image:
      'https://media.giphy.com/media/XOtxbCL6NLcyQxC7rv/giphy.gif',
    link: 'https://github.com/AndrewPalet/vet-payment-app',
  },
  {
    title: 'Responsive Portfolio Website - React',
    description:
      'Built a responsive portfolio website from scratch in React using Typescript, CSS, HTML, Material UI, Emotion, and deployed using Netlify',
    image: 'https://media.giphy.com/media/5hfUpdQERwKPRd5kdd/giphy.gif',
    link: 'https://github.com/AndrewPalet/andrewpalet-web',
  },
  {
    title: 'Flash Chat - Mobile App',
    description:
      'This is a mobile messaging app that allows for login and messaging between users. Created in Flutter using Dart and uses Firebase for authentication',
    image:
      'https://github.com/londonappbrewery/Images/raw/master/flash_chat_flutter_demo.gif',
    link: 'https://github.com/AndrewPalet/flash-chat-flutter',
  },
  {
    title: 'Web Scraper - Flask/Python',
    description:
      'This web application scrapes health information from a website and generates a csv with the scraped information.',
    image:
      'https://github.com/AndrewPalet/FlaskWebScraper/raw/master/static/img/WebAppScreenshot.PNG',
    link: 'https://github.com/AndrewPalet/FlaskWebScraper',
  }
]
